import type React from "react"

import type { IconProps } from "@/components/flow/icons/icon"

export const ChevronRight: React.FC<IconProps> = ({ color = "currentColor", ...attributes }) => {
  return (
    <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5.278 1.944 10.833 7.5l-5.555 5.555" />
    </svg>
  )
}
